module.exports = __webpack_public_path__ + "static/HF_TXFFC-cc8075ad0579c8a56f199ec9c8ef9d57.png";